// 20 ResetPassword.jsx — now using the http wrapper
import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import './AuthForms.css';
import { http } from '../lib/http';

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

export default function ResetPassword() {
  const token = useQuery().get('token');
  const navigate = useNavigate();
  const [password, setPassword] = useState('');
  const [confirm,  setConfirm]  = useState('');
  const [error,    setError]    = useState('');
  const [message,  setMessage]  = useState('');
  const [loading,  setLoading]  = useState(false);

  if (!token) {
    return (
      <div className="auth-page">
        <p>Invalid or missing reset token.</p>
      </div>
    );
  }

  const handleSubmit = async e => {
    e.preventDefault();
    setError(''); setMessage('');

    if (!password)           return setError('Password is required');
    if (password !== confirm) return setError('Passwords do not match');

    setLoading(true);
    try {
      const res = await http.postJson('/reset-password', {
        token,
        newPassword: password,
      });
      const data = await res.json().catch(() => ({}));
      if (!res.ok) throw new Error(data.message || 'Error resetting password');

      setMessage('Password updated! Redirecting to login…');
      setTimeout(() => navigate('/login'), 2000);
    } catch (err) {
      setError(err.message || 'Error resetting password');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-page">
      <form className="auth-form" onSubmit={handleSubmit}>
        <h1>Create New Password</h1>

        {error   && <div className="error-message">{error}</div>}
        {message && <div className="success-message">{message}</div>}

        <label>
          New Password
          <input
            type="password"
            value={password}
            onChange={e => setPassword(e.target.value)}
            required
          />
        </label>

        <label>
          Confirm Password
          <input
            type="password"
            value={confirm}
            onChange={e => setConfirm(e.target.value)}
            required
          />
        </label>

        <button type="submit" disabled={loading}>
          {loading ? 'Resetting…' : 'Reset Password'}
        </button>
      </form>
    </div>
  );
}
